import flowioast from "src/utils/flowioast";
import { RawFile, FileConfigParams } from "../types";
import {
  getErrorMsgForUploadFailedFiles,
  getRecordSubjectNumber,
  uploadAllNewFiles,
} from "../utils";

type UseUploadNewFiles = (
  params: FileConfigParams
) => (filesToUpload: RawFile[]) => Promise<void>;
const useUploadNewFiles: UseUploadNewFiles = (params) => {
  const {
    templateId,
    templateItemId,
    recordId,
    row,
    hegSubjectNumberColumnName,
  } = params;

  const recordSubjectNumber = getRecordSubjectNumber(
    row,
    hegSubjectNumberColumnName || null
  );

  const handleFailedUploadFiles = (
    failedIds: string[],
    filesToUpload: RawFile[]
  ): void => {
    if (!failedIds.length) return;

    const failedFilesString = getErrorMsgForUploadFailedFiles(
      failedIds,
      filesToUpload
    );
    flowioast.error.noStack.fromIntlId(
      "segments.file_input.files_upload.error",
      undefined,
      {
        fileNames: failedFilesString,
      }
    );
  };

  const uploadNewFiles = async (filesToUpload: RawFile[]): Promise<void> => {
    const uploadResponse = await uploadAllNewFiles({
      files: filesToUpload,
      templateId,
      templateItemId,
      recordId,
      recordSubjectNumber,
    });

    const { failed } = uploadResponse;

    handleFailedUploadFiles(failed, filesToUpload);
  };

  return uploadNewFiles;
};

export default useUploadNewFiles;
